module.exports = __webpack_public_path__ + "img/milestone-asset-2.2ef210eb.png";